import React, { useEffect, useState, useRef } from "react";
import ReactMarkdown from "react-markdown";
import "./NotificationStack.css";

const NotificationStack = ({ notification, duration = 5000 }) => {
  const [stack, setStack] = useState([]);
  const timersRef = useRef({});
  const lastRef = useRef(null);

  useEffect(() => {
    if (!notification) return;
    if (lastRef.current === notification) return;
    lastRef.current = notification;

    const id = crypto.randomUUID();

    setStack(prev => [
      {
        id,
        body: notification.body,
        title: notification.title,
        closing: false
      },
      ...prev
    ]);

    const closeTimer = setTimeout(() => {
      setStack(prev =>
        prev.map(n => (n.id === id ? { ...n, closing: true } : n))
      );
    }, duration - 350);

    const removeTimer = setTimeout(() => {
      setStack(prev => prev.filter(n => n.id !== id));
      delete timersRef.current[id];
    }, duration);

    timersRef.current[id] = { closeTimer, removeTimer };


  }, [notification, duration]);

  const manualRemove = (id) => {
    // Clear existing timers immediately
    if (timersRef.current[id]) {
      clearTimeout(timersRef.current[id].closeTimer);
      clearTimeout(timersRef.current[id].removeTimer);
      delete timersRef.current[id];
    }

    // Trigger closing animation
    setStack((prev) =>
      prev.map((n) => (n.id === id ? { ...n, closing: true } : n))
    );

    // Remove after animation
    setTimeout(() => {
      setStack((prev) => prev.filter((n) => n.id !== id));
    }, 350);
  };

  return (
    <div className="bos-notification-stack">
      {stack.map((note) => (
        <div
          key={note.id}
          className={`bos-notification-box ${note.closing ? "closing" : ""}`}
        >
          <div className="notification-header">
            <span className="title">{note.title || "Notification"}</span>
            <i
              onClick={() => manualRemove(note.id)}
              className="fa fa-times"
              aria-hidden="true"
            ></i>
          </div>

          <p className="notification-body">
            <ReactMarkdown>{note.body}</ReactMarkdown>
          </p>
        </div>
      ))}
    </div>
  );
};

export default NotificationStack;
